module.exports = __webpack_public_path__ + "img/HumanFemale_Archer.9c102035.png";